/**
 * Os grupos da tabela "Linhas com erro" do detalhe do upload (2026-10-30) —
 * espelho de `core.vocabulary.ERROR_LINE_GROUPS` e `ERROR_LINE_STATES`, com
 * paridade travada por `tests/test_error_line_group_parity.py` (lê este
 * arquivo, inclusive a SEQUÊNCIA, que é a ordem de exibição).
 *
 * Os seis grupos do meio são as abas dos baldes da fila de correção e
 * reusam os rótulos delas (`TAB_LABELS`); "Arquivo" (erro sem linha) vai
 * no topo e "Avisos" (menção criada, tarefa de IA falhou) por último.
 */

import { TAB_LABELS, type CorrectionTab } from "@/features/uploads/correction-group-tabs";

export const ERROR_LINE_GROUPS = [
  "file",
  "catalog",
  "imported",
  "duration",
  "scrape",
  "no_brand",
  "other",
  "warning"
] as const;

export type ErrorLineGroup = (typeof ERROR_LINE_GROUPS)[number];

export const ERROR_LINE_GROUP_LABELS: Record<ErrorLineGroup, string> = {
  file: "Arquivo",
  warning: "Avisos (menção criada, tarefa de IA falhou)",
  ...(TAB_LABELS satisfies Record<CorrectionTab, string>)
};

export const ERROR_LINE_STATES = [
  "pending",
  "queued",
  "reprocessed",
  "discarded",
  "none"
] as const;

export type ErrorLineState = (typeof ERROR_LINE_STATES)[number];

/** O chip de estado da linha; `none` não mostra nada. */
export const ERROR_LINE_STATE_LABELS: Record<ErrorLineState, string | null> = {
  pending: "pendente",
  queued: "na fila",
  reprocessed: "resolvida",
  discarded: "descartada",
  none: null
};
